import { useReducer } from 'react';

import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../common/';
import VehicleSelectV2 from '../../common/Components/VehicleSelectV2';
import TopNav from '../../main/components/TopNav';
import VehicleSubscription from './VehicleSubscription';

interface PacksLayoutState {
    vehcode: number;
}

const PacksLayout: React.FC = () => {
    const initialState: PacksLayoutState = {
        vehcode: -1,
    };
    const [state, setState]: [PacksLayoutState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const { t } = useTranslation();

    function onVehicleChange(event: any) {
        setState({
            vehcode: event,
        });
    }

    return (
        <React.Fragment>
            <TopNav
                items={[
                    {
                        to: `${config.BaseURL}`,
                        label: t('breadcrumbs.menu'),
                    },
                    {
                        to: '#',
                        label: t('breadcrumbs.subscription'),
                    },
                ]}
            />
            <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw-servicos-value-service-prime'])}>
                <div className={'cell'}>
                    <span className={'pacote-titulo'}>{t('subscriptions:header')}</span>
                </div>
                <VehicleSelectV2 onChange={onVehicleChange} isMini={false} />
                <VehicleSubscription vehcode={state.vehcode} />
            </div>

        </React.Fragment>
    );
};

export default PacksLayout;
